import { CheckIcon, RepeatClockIcon } from '@chakra-ui/icons';
import { Flex, FlexProps, Text, defineStyle } from '@chakra-ui/react';
import { useState } from 'react';

const alertContainerStyles = defineStyle({
  width: 'auto',
  wordBreak: 'keep-all',
  gap: '10px',
  alignItems: 'center',
  padding: '10px',
  border: '1px solid',
  borderRadius: '12px',
  position: 'absolute',
  bottom: { base: '10px', lg: '36px' },
  left: { base: '10px', lg: '36px' },
  backgroundColor: 'bgColor.100',
  zIndex: 1,
  maxW: '350px',
  cursor: 'pointer',
  fontSize: { base: '12px', sm: '14px' },
}) as FlexProps;

type AlertProps = {
  message: string;
  status: 'success' | 'error';
};

export const Alert = ({ message, status }: AlertProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    isOpen && (
      <Flex
        {...alertContainerStyles}
        borderColor={status === 'error' ? 'red' : 'green.100'}
        onClick={() => setIsOpen(false)}
      >
        {status === 'error' ? (
          <RepeatClockIcon w={'20px'} h={'20px'} color={'red'} />
        ) : (
          <CheckIcon w={'20px'} h={'20px'} color={'green.100'} />
        )}
        <Text as={'span'} wordBreak={'keep-all'}>
          {message}
        </Text>
      </Flex>
    )
  );
};
